import React from 'react'

const Box = ({ children , title, className}) => {
    return (
        <div className={`bg-secondary w-full p-4 border border-transparent hover:border-bordercolor ${className}`}>
            <h4 className={`text-bordercolor2 font-medium `}>{title}</h4>
            <span className="font-light text-xl">
                {children}
            </span>
        </div>
    )
}

export default Box
